const genderLabelMap: Record<server.dto.Genders, string> = {
  unspecified: RESX.GeneralLabels.Unspecified,
  other: RESX.Genders.Other,
  female: RESX.Genders.Female,
  male: RESX.Genders.Male
}

export const getGenderName = (gender: server.dto.Genders) => genderLabelMap[gender];